import { GenericServiceResponse } from './generic-service-response';
import { ResponseCachedDecorator } from './decorators/response-cached.decorator';
import { GetByIdentityResponseInterface, IdentityInterface, ModelInterface } from '@nts/std/interfaces';


@ResponseCachedDecorator({onlyOffline: true})
export class GetByIdentityResponse<
    TModel extends ModelInterface<TIdentity>,
    TIdentity extends IdentityInterface>
    extends GenericServiceResponse<TModel> implements GetByIdentityResponseInterface<TModel, TIdentity> {

}
